import React from "react"
import './style.css'
import ImgBannerCannon from '../../../images/banner_canon.jpg'

/* eslint import/no-webpack-loader-syntax: off */
import SvgFrameLeftBottom from "-!svg-react-loader!../../../icons/frame-left-bottom.svg";
import SvgArtBoxOpacity from "-!svg-react-loader!../../../icons/art-box-opacity.svg";
import SvgArtBox from "-!svg-react-loader!../../../icons/art-box.svg";

export default function Index() {
    const scrollToElement = () => {
        const elem = document.getElementById('send-us-message');
        if(elem) {
            elem.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
        }
    }
    return (
        <section className="section banner">
            <div className="main-container">
                <div className="banner__wrapper">
                    <div className="banner__content">
                        <h1 className="banner__title">Fine Art Printing</h1>
                        <p className="banner__text">
                            We print photographs and digital art for private individuals and
                            companies using the latest technology and a range of high quality,
                            acid free papers.
                        </p>
                        <p className="banner__text">
                            Simply get in touch with us to discuss your printing needs and let
                            us see if we can help.
                        </p>
                        <button className="banner__btn" onClick={scrollToElement} type="button">Order now</button>
                    </div>
                    <div className="banner__image">
                        <div className="banner__photo">
                            <img src={ImgBannerCannon} alt="canon printer"/>
                            <SvgArtBox
                                className="banner__icon--white"
                                width="236"
                                height="111"
                                viewBox="0 0 236 111"
                            />
                            <SvgArtBox
                                className="banner__icon--rigth-up"
                                width="150"
                                height="90"
                                viewBox="0 0 150 90"
                            />

                            <SvgArtBoxOpacity className="banner__icon--center-left"/>

                            <SvgFrameLeftBottom className="banner__icon--left-down"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


// WEBPACK FOOTER //
// ./src/new-components/templates/art-banner/index.js